import React, { useEffect, useState } from "react";
import { FalkeCoinLogo } from "./Brand";
import { Trophy } from "lucide-react";
import { fireConfetti } from "./Confetti";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * StufenaufstiegModal: Erkennt eine ungelesene Notification vom Typ "stufenaufstieg"
 * und zeigt einen Fullscreen-Wow-Moment. Nach Bestätigung wird die Notification als gelesen markiert.
 */
export default function StufenaufstiegModal() {
  const { user } = useAuth();
  const [notif, setNotif] = useState(null);
  const [closing, setClosing] = useState(false);
  const [showCloseBtn, setShowCloseBtn] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const r = await api.get("/me/notifications");
        const unread = (r.data || []).find((n) => n.kind === "stufenaufstieg" && !n.gelesen);
        if (unread && !cancelled) {
          setNotif(unread);
          fireConfetti("strong");
        }
      } catch {}
    };
    check();
    const t = setInterval(check, 45000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  useEffect(() => {
    if (notif) {
      const t = setTimeout(() => setShowCloseBtn(true), 1500);
      return () => clearTimeout(t);
    }
  }, [notif]);

  const close = async () => {
    setClosing(true);
    try { await api.post(`/me/notifications/${notif.id}/read`); } catch {}
    setTimeout(() => { setNotif(null); setClosing(false); setShowCloseBtn(false); }, 200);
  };

  if (!notif || !user || user.role !== "kunde") return null;

  // Extrahiere Stufe aus title (z.B. "Stufenaufstieg: Gold!")
  const match = /Stufenaufstieg:\s*(\w+)/i.exec(notif.title || "");
  const stufe = match ? match[1] : (user.aktuelle_stufe || "Neue Stufe");

  return (
    <div className={`fixed inset-0 z-[60] flex items-center justify-center p-6 bg-gradient-to-br from-falke-blue/80 to-falke-blue-dark/90 backdrop-blur-sm ${closing ? "opacity-0 transition-opacity duration-200" : ""}`} data-testid="stufenaufstieg-modal">
      <div className="text-center text-white max-w-md">
        <div className="trophy-pop inline-block">
          <div className="relative">
            <FalkeCoinLogo size={120} glow />
            <Trophy className="absolute -top-4 -right-4 text-falke-gold drop-shadow-lg" size={48} fill="currentColor" />
          </div>
        </div>
        <div className="mt-6 text-xs uppercase tracking-[0.3em] text-falke-gold font-semibold">Stufenaufstieg</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2">Glückwunsch!</h1>
        <p className="text-lg mt-3 text-white/90">
          Du bist jetzt <span className="text-falke-gold font-bold">{stufe}-Empfehler</span> bei FalkeTek.
        </p>
        <p className="text-sm text-white/70 mt-2">{notif.body}</p>
        {showCloseBtn && (
          <button onClick={close} className="btn-primary mt-8 inline-flex items-center gap-2" data-testid="stufenaufstieg-close">
            Weiter zum Konto
          </button>
        )}
      </div>
    </div>
  );
}
